export default value => (value ? 'Administrator' : 'Bruger');
